/* MFW cart drawer + "Complete your build" upsells. Markup/settings: sections/mfw-cart-drawer.liquid */
(function () {
  // Guard on the API itself (element ids also show up as window properties).
  if (window.MfwCartDrawer && window.MfwCartDrawer.added) return;

  var SECTION_ID = 'mfw-cart-drawer';
  var CONFIG = {};
  try {
    CONFIG = JSON.parse(document.getElementById('mfw-cart-drawer-config').textContent);
  } catch (e) {}
  var CART_URL = CONFIG.cartUrl || '/cart';
  var ADD_URL = (CONFIG.cartAddUrl || '/cart/add') + '.js';
  var CHANGE_URL = (CONFIG.cartChangeUrl || '/cart/change') + '.js';
  var UPDATE_URL = (CONFIG.cartUpdateUrl || '/cart/update') + '.js';
  var RECS_URL = (CONFIG.recommendationsUrl || '/recommendations/products') + '.json';
  var MONEY_FORMAT = CONFIG.moneyFormat || '${{amount}}';
  var ADD_TEXT = CONFIG.addText || 'Add';
  var OPTIONS_TEXT = CONFIG.optionsText || 'View';
  var ADDED_TEXT = CONFIG.addedText || 'Added';
  var ERROR_TEXT = CONFIG.errorText || 'Something went wrong. Please try again.';
  var MAX_SUGGESTIONS = CONFIG.maxSuggestions || 4;
  var PDP_MAX = CONFIG.pdpMaxProducts || 2;

  var drawer = document.getElementById('mfw-cart-drawer-root');
  if (!drawer) return;
  var panel = drawer.querySelector('.mfw-cdr__panel');
  var lastFocus = null;
  var recsCache = {};

  // The drawer section only builds the full cart (items, upsells, totals) when rendered
  // for the cart page path, so normal page loads stay light. Always render it there.
  function sectionsUrl() {
    return CART_URL;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents) {
    var value = (Number(cents) || 0) / 100;
    var match = MONEY_FORMAT.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    var decimals = key.indexOf('no_decimals') !== -1 ? 0 : 2;
    var parts = value.toFixed(decimals).split('.');
    var sep = key.indexOf('comma_separator') !== -1 ? ['.', ','] : [',', '.'];
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep[0]);
    var amount = parts.join(sep[1]);
    return match ? MONEY_FORMAT.replace(match[0], amount) : '$' + amount;
  }

  function updateCount(count) {
    document.querySelectorAll('.mf-cart-count').forEach(function (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? '' : 'none';
    });
    if (count > 0) {
      document.querySelectorAll('.mf-header__utilities a[href="' + CART_URL + '"]').forEach(function (link) {
        if (!link.querySelector('.mf-cart-count')) {
          var badge = document.createElement('span');
          badge.className = 'mf-cart-count';
          badge.textContent = count;
          link.appendChild(badge);
        }
      });
    }
  }

  function refreshAffirm() {
    try {
      if (window.affirm && affirm.ui && typeof affirm.ui.ready === 'function') {
        affirm.ui.ready(function () { affirm.ui.refresh(); });
      }
    } catch (e) {}
  }

  function showError(message) {
    var box = drawer.querySelector('[data-mfw-cdr-error]');
    if (!box) return;
    box.textContent = message || ERROR_TEXT;
    box.hidden = false;
  }

  // Swap in freshly rendered drawer HTML (from the Section Rendering API).
  function applySection(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var freshBody = doc.querySelector('[data-mfw-cdr-body]');
    var body = drawer.querySelector('[data-mfw-cdr-body]');
    if (freshBody && body) {
      body.innerHTML = freshBody.innerHTML;
      drawer.setAttribute('data-loaded', 'true');
    }


    shuffleTrim(drawer.querySelector('[data-mfw-cdr-suggest]'));
    var items = drawer.querySelector('.mfw-cdr__items');
    updateCount(items ? countItems() : 0);
    refreshAffirm();
    loadComplementary();
  }

  // Shuffle a rendered pool of suggestions and keep only data-max of them.
  function shuffleTrim(list) {
    if (!list) return;
    var max = parseInt(list.getAttribute('data-max'), 10) || 4;
    var items = Array.prototype.slice.call(list.children);
    for (var i = items.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = items[i]; items[i] = items[j]; items[j] = tmp;
    }
    items.forEach(function (item, index) {
      if (index < max) list.appendChild(item);
      else item.remove();
    });
  }

  function countItems() {
    var total = 0;
    drawer.querySelectorAll('.mfw-cdr__qty-value').forEach(function (el) {
      total += parseInt(el.textContent, 10) || 0;
    });
    return total;
  }

  // Re-render the drawer from the live cart. A POST to /cart/update.js is never served
  // from a cache, so the very first add (when the cart cookie is brand new) shows up
  // immediately; a cached GET of ?sections= could still return the empty-cart version.
  function refresh() {
    drawer.classList.add('is-busy');
    return fetch(UPDATE_URL, {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: {}, sections: SECTION_ID, sections_url: sectionsUrl() })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('update failed');
        return r.json();
      })
      .then(function (cart) {
        if (cart && cart.sections && cart.sections[SECTION_ID]) return applySection(cart.sections[SECTION_ID]);
        throw new Error('no section');
      })
      .catch(function () {
        // Fallback: cache-busted GET render.
        return fetch(sectionsUrl() + '?sections=' + SECTION_ID + '&_=' + Date.now(), {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        })
          .then(function (r) { return r.json(); })
          .then(function (data) { applySection(data && data[SECTION_ID]); })
          .catch(function () {});
      })
      .then(function () { drawer.classList.remove('is-busy'); });
  }

  function trapFocus(event) {
    if (event.key === 'Escape') {
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    var focusable = panel.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function ensureLoaded() {
    if (drawer.getAttribute('data-loaded') === 'true') return Promise.resolve();
    if (!drawer._loading) drawer._loading = refresh();
    return drawer._loading;
  }

  function open() {
    ensureLoaded();
    if (drawer.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('mfw-cdr-lock');
    document.addEventListener('keydown', trapFocus);
    window.setTimeout(function () {
      var closeBtn = drawer.querySelector('.mfw-cdr__close');
      (closeBtn || panel).focus();
    }, 60);
  }

  function close() {
    if (!drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('mfw-cdr-lock');
    document.removeEventListener('keydown', trapFocus);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  // Product page: show "Complete your build" under Add to cart.
  function showProductPanel() {
    var slot = document.querySelector('[data-mfw-up-slot]');
    var tpl = document.querySelector('template[data-mfw-up-template]');
    if (!slot || !tpl) return false;
    var html = tpl.innerHTML.trim();
    if (!html) return false;
    slot.innerHTML = html;
    shuffleTrim(slot.querySelector('[data-mfw-up-products]'));
    loadComplementaryForPanel(slot.querySelector('[data-mfw-up-panel]'));
    return true;
  }

  // Called after any successful add-to-cart on the site.
  function added(options) {
    options = options || {};
    var onProduct = drawer.getAttribute('data-template') === 'product' && !!document.querySelector('[data-mfw-up-slot]');
    return refresh().then(function () {
      var panelShown = options.fromProductForm && onProduct ? showProductPanel() : false;
      var shouldOpen = onProduct && options.fromProductForm
        ? drawer.getAttribute('data-open-on-product') === 'true'
        : drawer.getAttribute('data-open-on-add') === 'true';
      if (shouldOpen || (!panelShown && options.fromProductForm)) open();
    });
  }

  function changeLine(line, quantity) {
    drawer.classList.add('is-busy');
    return fetch(CHANGE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: SECTION_ID, sections_url: sectionsUrl() })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw data;
          return data;
        });
      })
      .then(function (cart) {
        if (cart.sections && cart.sections[SECTION_ID]) applySection(cart.sections[SECTION_ID]);
        else return refresh();
      })
      .catch(function (err) {
        refresh().then(function () { showError(err && (err.description || err.message)); });
      })
      .then(function () { drawer.classList.remove('is-busy'); });
  }

  function quickAdd(form) {
    var button = form.querySelector('button[type="submit"]');
    if (button) button.classList.add('is-loading');
    var data = new FormData(form);
    data.append('sections', SECTION_ID);
    data.append('sections_url', sectionsUrl());
    return fetch(ADD_URL, { method: 'POST', headers: { Accept: 'application/json' }, body: data })
      .then(function (r) {
        return r.json().then(function (payload) {
          if (!r.ok) throw payload;
          return payload;
        });
      })
      .then(function (payload) {
        if (button) {
          button.classList.remove('is-loading');
          button.classList.add('is-added');
          button.textContent = ADDED_TEXT;
        }
        var insideDrawer = drawer.contains(form);
        if (payload.sections && payload.sections[SECTION_ID]) applySection(payload.sections[SECTION_ID]);
        else refresh();
        if (!insideDrawer) open();
      })
      .catch(function (err) {
        if (button) button.classList.remove('is-loading');
        if (drawer.contains(form)) showError(err && err.description);
        else if (button) button.textContent = ERROR_TEXT;
      });
  }

  // ---- Shopify Search & Discovery "complementary products" (when set up) ----
  function productCard(product, layout) {
    var variant = (product.variants || []).filter(function (v) { return v.available; })[0];
    var image = product.featured_image ? product.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') : '';
    if (image && image.indexOf('//') === 0) image = 'https:' + image;
    var price = (product.price_varies ? 'From ' : '') + formatMoney(product.price);
    var single = product.variants && product.variants.length === 1 && variant;
    var action = single
      ? '<form class="mfw-up-product__form" action="' + ADD_URL.replace(/\.js$/, '') + '" method="post" data-mfw-quick-add>' +
          '<input type="hidden" name="id" value="' + variant.id + '"><input type="hidden" name="quantity" value="1">' +
          '<button type="submit" class="mfw-up-product__btn" aria-label="' + escapeHtml(ADD_TEXT + ': ' + product.title) + '"><span aria-hidden="true">+</span> ' + escapeHtml(ADD_TEXT) + '</button>' +
        '</form>'
      : '<a class="mfw-up-product__btn mfw-up-product__btn--outline" href="' + escapeHtml(product.url) + '">' + escapeHtml(OPTIONS_TEXT) + '</a>';
    return '<li class="mfw-up-product mfw-up-product--' + layout + '">' +
      '<a class="mfw-up-product__media" href="' + escapeHtml(product.url) + '" tabindex="-1" aria-hidden="true">' +
        (image ? '<img src="' + escapeHtml(image) + (image.indexOf('?') === -1 ? '?' : '&') + 'width=240" alt="" width="120" height="120" loading="lazy">' : '') +
      '</a>' +
      '<div class="mfw-up-product__info"><a class="mfw-up-product__title" href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + '</a>' +
      '<span class="mfw-up-product__price">' + escapeHtml(price) + '</span></div>' + action + '</li>';
  }

  function fetchComplementary(productId) {
    if (!productId) return Promise.resolve([]);
    if (recsCache[productId]) return recsCache[productId];
    recsCache[productId] = fetch(RECS_URL + '?product_id=' + encodeURIComponent(productId) + '&intent=complementary&limit=6', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) { return (data && data.products) || []; })
      .catch(function () { return []; });
    return recsCache[productId];
  }

  function usable(product, inCart) {
    return product && product.available && product.price > 0 && inCart.indexOf(',' + product.handle + ',') === -1;
  }

  function loadComplementary() {
    if (drawer.getAttribute('data-complementary') !== 'true') return;
    var items = drawer.querySelector('.mfw-cdr__items');
    var list = drawer.querySelector('[data-mfw-cdr-suggest]');
    var wrap = drawer.querySelector('[data-mfw-cdr-suggest-wrap]');
    if (!items || !list || !wrap) return;
    var inCart = items.getAttribute('data-in-cart') || ',';
    fetchComplementary(items.getAttribute('data-first-product-id')).then(function (products) {
      var picks = products.filter(function (p) { return usable(p, inCart); }).slice(0, MAX_SUGGESTIONS);
      if (!picks.length || !drawer.contains(list)) return;
      list.innerHTML = picks.map(function (p) { return productCard(p, 'card'); }).join('');
      wrap.hidden = false;
    });
  }

  function loadComplementaryForPanel(panelEl) {
    if (!panelEl || drawer.getAttribute('data-complementary') !== 'true') return;
    var list = panelEl.querySelector('[data-mfw-up-products]');
    var items = drawer.querySelector('.mfw-cdr__items');
    var inCart = (items && items.getAttribute('data-in-cart')) || ',';
    fetchComplementary(panelEl.getAttribute('data-product-id')).then(function (products) {
      var picks = products.filter(function (p) { return usable(p, inCart); }).slice(0, Math.max(PDP_MAX, 2));
      if (!picks.length || !list) return;
      list.innerHTML = picks.map(function (p) { return productCard(p, 'row'); }).join('');
      list.hidden = false;
    });
  }

  // ---- Events ----
  document.addEventListener('click', function (event) {
    var closer = event.target.closest('[data-mfw-cart-close]');
    if (closer && drawer.contains(closer)) {
      event.preventDefault();
      close();
      return;
    }

    var qty = event.target.closest('[data-mfw-cart-qty]');
    if (qty && drawer.contains(qty)) {
      event.preventDefault();
      changeLine(parseInt(qty.getAttribute('data-line'), 10), Math.max(0, parseInt(qty.getAttribute('data-qty'), 10) || 0));
      return;
    }

    // Header cart icon (and anything marked data-mfw-cart-open) opens the drawer.
    var opener = event.target.closest('[data-mfw-cart-open], .mf-header__utilities a[href="' + CART_URL + '"]');
    if (opener && drawer.getAttribute('data-template') !== 'cart' && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
      event.preventDefault();
      open();
      refresh();
    }
  });

  // Warm the drawer up when the customer heads for the cart icon, so it opens filled.
  ['pointerover', 'touchstart', 'focusin'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      if (event.target.closest && event.target.closest('[data-mfw-cart-open], .mf-header__utilities a[href="' + CART_URL + '"]')) ensureLoaded();
    }, { passive: true });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-mfw-quick-add]');
    if (!form) return;
    event.preventDefault();
    quickAdd(form);
  });

  // ---- Hook into the theme's existing add-to-cart flows ----
  // Product page, collection grids, Top Collections and the USF search grid all call
  // MfwTopCollections.showCartToast after a successful add; the drawer replaces that toast.
  function drawerToast(opts) {
    added({ fromProductForm: !!(opts && opts.fromProductForm) });
  }

  function installHooks() {
    var api = window.MfwTopCollections = window.MfwTopCollections || {};
    // Re-applied on DOMContentLoaded / load in case a section script defined its own toast later.
    if (api.showCartToast !== drawerToast) api.showCartToast = drawerToast;

    // Ultimate Search & Filter quick add (search results).
    if (typeof window._usfOnAddToCartSuccess !== 'function') {
      window._usfOnAddToCartSuccess = function () { added({}); };
    }
  }

  window.MfwCartDrawer = { open: open, close: close, refresh: refresh, added: added, showProductPanel: showProductPanel };
  installHooks();
  if (drawer.getAttribute('data-loaded') === 'true') {
    shuffleTrim(drawer.querySelector('[data-mfw-cdr-suggest]'));
    loadComplementary();
  }
  document.addEventListener('DOMContentLoaded', installHooks);
  window.addEventListener('load', installHooks);
})();
